const BlankLayoutRoutes = {
    path: '/',
    component: () => import('@/layouts/blank/BlankLayout.vue'),
    meta: {
        requiresAuth: false,
    },
    children: [
        {
            path: '/EmployeeCardQR/:id?',
            name: 'EmployeeCardQR',
            props: true,
            component: () => import('@/views/QR/EmployeeCardQRView.vue'),
        },
        //{
        //    name: 'maintenance',
        //    path: '/auth/maintenance',
        //    component: () => import('@/views/components/sm-components/sm-maintenance.vue')
        //},
        {
            path: '/user/kpi/:id',
            component: () => import('@/views/Performance/KPIView.vue'),
            props: true,
        },
        {
            path: '/Staffing/EmployeeProfile/NSMApplicationForm/:id',
            component: () => import('@/views/Staffing/EmployeeProfile/ApplicationFormView.vue'),
            props: true,
        },
        {
            path: '/Staffing/EmployeeProfile/BSMApplicationForm/:id',
            component: () => import('@/views/Staffing/EmployeeProfile/BSMApplicationFormView.vue'),
            props: true,
        },
        {
            path: '/payroll/mission',
            component: () => import('@/views/Payroll/Mission/MissionRequestFormView.vue'),
        },
        {
            path: '/Performance/Probationary-Form',
            component: () => import('@/views/Performance/User/Probationary/ProbationaryEvaluationFormView.vue'),
        },
        {
            path: '/internal-rule',
            component: () => import('@/layouts/full/vertical-header/InternalRule.vue'),
        },
        {
            path: '/frames/publish',
            name: 'Public Frames',
            component: () => import('@/views/frames/PublicFrames.vue'),
            meta: {
                requiresAuth: false,
                title: 'Public Frames',
            },
        }

    ],
}

export default BlankLayoutRoutes
